import * as React from "react";
const SvgBackArrowDark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, fill: "none", style: {
  marginTop: 2
}, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#808BA2", d: "M18.82 9.18H5.42l3.9-3.9L8.16 4.1l-5.9 5.92 5.88 5.88 1.17-1.18-3.87-3.87h13.39z" }));
export default SvgBackArrowDark;
